module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            message: '@',
            mode: '@?'
        },
        link(scope) {
            scope.mode = scope.mode || 'polite'; // Three options are "assertive ", "polite", and "Off".  It is recommended to always use "polite" unless you want a message to be conveyed immediately
        },
        template: '<span class="sr-only" role="status" aria-live="{{mode}}" aria-atomic="true" ng-bind="message"></span>',
        replace: true
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/accessiblity/sr-notification-directive.js
 **/